require('../../modules/es.object.assign');
var path = require('../../internals/path');

module.exports = path.Object.assign;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/assign.js
// module id = 3490
// module chunks = 25